/** Picks the AI-mode backend: mock (default) or /api/v1 (same origin/session as ../index.ts). */
import { getApi, useMock } from '../index'
import { MockChatApi } from '../mock'
import { HttpAiModeApi } from './http'
import { emitMockAiMode, MockAiModeApi } from './mock'
import type { AiModeApi } from './types'

let current: AiModeApi | null = null

export function getAiModeApi(): AiModeApi {
  if (!current) {
    const chat = getApi()
    if (useMock && chat instanceof MockChatApi) {
      current = new MockAiModeApi(chat)
      // mock mode only (screens): lets test/screens-aimode.mjs switch states
      if (typeof window !== 'undefined') {
        const w = window as unknown as { __cfAiModeMock?: AiModeApi; __cfAiModeEmit?: typeof emitMockAiMode }
        w.__cfAiModeMock = current
        w.__cfAiModeEmit = emitMockAiMode // "the AI handed a chat to you" alert on the screens
        // `npm run dev`: c150 shows "AI กำลังคิด → กำลังพิมพ์ → ฟอง" every minute (never under a test runner / browser automation)
        if (import.meta.env.MODE !== 'test' && !navigator.webdriver) (current as MockAiModeApi).startDemo()
      }
    } else current = new HttpAiModeApi((import.meta.env.VITE_API_BASE ?? '').trim())
  }
  return current
}

/** Tests inject their own backend. */
export function setAiModeApi(api: AiModeApi | null): void {
  current = api
}

export type * from './types'
export { HANDOFF_LABEL, isAiModeEvent } from './types'
